import React, { useState, useEffect } from "react";
import { getAllProducts } from "../../services/product/product";
import {
    getAllSubstitutionById, newSubstitution, updateSubstitution,
    removeSubstitution,
} from "../../services/product/substitution";
import { Button } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { PlusCircle, Trash2 } from "react-feather";
import SubstitutionForm from "../../core/modals/products/substitutionFormModel";
import { useParams } from "react-router-dom";



const SubstitutionPage = () => {
    const { id } = useParams();
    const [listData, setListData] = useState([]);
    const [productListData, setProductListData] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [showModel, setModelShow] = useState(false);
    const [selectedData, setSelectedData] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        fetchRecords();
    }, []);

    const fetchRecords = async () => {
        try {
            if (id) {
                const data = await getAllSubstitutionById(id);
                setListData(data);
            }
            const data = await getAllProducts();
            setProductListData(data);
        } catch (err) {
            console.error("Failed to load addresses:", err.message);
        }
    };

    const filteredData = listData.filter((item) =>
        Object.values(item).some(
            (value) =>
                typeof value === "string" &&
                value.toLowerCase().includes(searchTerm.toLowerCase())
        )
    );

    const handleShow = () => {
        setSelectedData(null);
        setModelShow(true)
    };

    const handleClose = () => setModelShow(false);
    const handleAdd = async (data) => {
        try {
            if (data.ProductSubstitutionID) {
                await updateSubstitution(data);
            }
            else {
                await newSubstitution(data);
            }
            await fetchRecords();
            setModelShow(false);
        } catch (err) {
            console.error("Error creating user:", err.message);
        }
    };

    const handleDeleteSubstitution = async (row) => {
        const subId = Number(row?.ProductSubstitutionID) || 0;
        if (!subId) return console.error("Missing ProductSubstitutionID:", row);

        if (!window.confirm("Delete this substitution?")) return;

        try {
            await removeSubstitution(subId);
            await fetchRecords();
        } catch (err) {
            alert(err?.response?.data?.Message || "Failed to delete Substitution.");
        }
    };

    const handleEdit = (record) => {
        setSelectedData(record);
        setModelShow(true);
    };

    return (
        <div className="page-wrapper">
            <div className="content">
                <div className="page-header">
                    <div className="add-item d-flex">
                        <div className="page-title">
                            <h4>Substitutions</h4>
                            <h6>Manage Your Substitution</h6>
                        </div>
                    </div>
                    <div className="page-btn">
                        <Button variant="none" className="btn btn-added" onClick={handleShow}>
                            <PlusCircle className="me-2" />
                            Add New Substitution
                        </Button>
                    </div>
                </div>
                <div className="card table-list-card">
                    <div className="card-body">
                        <div className="table-top">
                            <div className="search-set">
                                <div className="search-input">
                                    <input
                                        type="text"
                                        placeholder="Search"
                                        className="form-control"
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                    />
                                    <Link to className="btn btn-searchset">
                                        <i data-feather="search" className="feather-search" />
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className="table-responsive">
                            <table className="table table-bordered table-striped">
                                <thead>
                                    <tr>
                                        <th>Product Name</th>
                                        <th>Product Substitution</th>
                                        <th>Is Quantified</th>
                                        <th>Quantity</th>
                                        <th>Is ExtraCharge</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredData.length > 0 ? (
                                        filteredData.map((item, index) => (
                                            <tr key={index}>
                                                <td>{item.ProductName || "N/A"}</td>
                                                <td>{item.ProductSubstitute || "N/A"}</td>
                                                <td>{item.IsQuantified ? "Yes" : "No"}</td>
                                                <td>{item.Quantity}</td>
                                                <td>{item.IsExtraCharge ? "Yes" : "No"}</td>
                                                <td>
                                                    <button type='button'
                                                        onClick={() => handleEdit(item)}
                                                        className="btn btn-sm btn-primary me-2">
                                                        <i className="feather-edit"></i>
                                                    </button>
                                                    <button
                                                        type="button"
                                                        onClick={() => handleDeleteSubstitution(item)}
                                                        className="btn btn-sm btn-light me-2"
                                                        title="Delete"
                                                        style={{ border: "1px solid #f1c0c0" }}
                                                    >
                                                        <Trash2 size={16} color="red" />
                                                    </button>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="6" className="text-center">
                                                No records found
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            {showModel &&
                <SubstitutionForm
                    onSubmit={handleAdd}
                    showModel={showModel}
                    handleClose={handleClose}
                    data={selectedData}
                    productList={productListData}
                    id={id}
                />
            }
        </div>
    );
};


export default SubstitutionPage;
